import { BellRing, TrendingUp, TrendingDown, ShieldAlert, UserPlus } from "lucide-react";

const NOTIFS = [
  { icon: TrendingUp, color: "text-green-600 bg-green-100 dark:bg-green-900/30", t: "Yeni yatırım onaylandı", d: "SRL212 · 42.500 ₺", time: "2 dk önce" },
  { icon: UserPlus, color: "text-blue-600 bg-blue-100 dark:bg-blue-900/30", t: "Yeni kullanıcı kaydı", d: "vip8842 · SRL189", time: "11 dk önce" },
  { icon: TrendingDown, color: "text-red-500 bg-red-100 dark:bg-red-900/30", t: "Çekim talebi bekliyor", d: "SRL001 · 8.900 ₺", time: "23 dk önce" },
  { icon: ShieldAlert, color: "text-amber-500 bg-amber-100 dark:bg-amber-900/30", t: "Şüpheli işlem tespit edildi", d: "SRL240 · inceleniyor", time: "1 saat önce" },
  { icon: TrendingUp, color: "text-green-600 bg-green-100 dark:bg-green-900/30", t: "Günlük ciro hedefi aşıldı", d: "SRL212 · +12%", time: "3 saat önce" },
];

export default function Bildirimler() {
  return (
    <div className="space-y-5 max-w-3xl" data-testid="page-bildirimler">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <BellRing className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Bildirimler</h1>
          <p className="text-xs text-slate-500">Son sistem olayları</p>
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 divide-y divide-slate-100 dark:divide-slate-800">
        {NOTIFS.map((n, i) => (
          <div key={i} className="flex items-center gap-4 p-4 hover:bg-slate-50 dark:hover:bg-slate-800/50">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${n.color}`}><n.icon size={18} /></div>
            <div className="flex-1">
              <div className="font-semibold text-sm">{n.t}</div>
              <div className="text-xs text-slate-500">{n.d}</div>
            </div>
            <span className="text-xs text-slate-400 whitespace-nowrap">{n.time}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
